$(document).ready(function () {
  
  $('#shopify-section-template--16000394035390__16476920169a4b96e2').after($('#section-text-columns-with-icons'));

   $('#closeMczr').click(function(){
    history.back();
   });

  $('#refreshMczr').click(function(){
    $( '#mczrProductIframe' ).attr( 'src', function ( i, val ) { return val; });
  });

  $('.mczr_button').css('opacity',0.9);
  
  $('.product__sample').click(function() {
  	var url = $(this).data('url');
    window.location.href=url;
 });
  
  $('.remove-labels-link').click(function() {
    $('.remove.label-product')[0].click();
  });

  $(document).on('click', '.remove-denim-labels-link', function() {
    $('.remove.denim-label-product')[0].click();
  });

  if ( typeof ExtendCartLabels === 'function' ) {
    ExtendCartLabels();
  }

  // Recalcula os botões de labels sempre que o conteúdo do carrinho é
  // re-renderizado (add-to-cart, mudança de quantidade, remoção, apps...),
  // independentemente do timing das chamadas do tema.
  if ( typeof MutationObserver !== 'undefined' ) {
    document.querySelectorAll('#AjaxCartForm, cart-form').forEach(function(form) {
      if ( form.__labelObserved ) { return; }
      form.__labelObserved = true;
      var observer = new MutationObserver(function() {
        if ( typeof ExtendCartLabels === 'function' ) {
          ExtendCartLabels();
        }
      });
      observer.observe(form, { childList: true });
    });
  }
  
})
         
function ExtendCartLabels() {

  const labelStock = parseInt($('#label_stock_qty').val());
  var rules = window.WATCLabelState ? window.WATCLabelState() : null;

  var totalQty = 0;
  var neckSelector = (rules && rules.hasPrint && rules.hasNeck)
    ? '.cart-item[data-applied-label="Custom Neck Label"]:not([data-no-label]) .cart-qty'
    : '.cart-item:not([data-no-label]) .cart-qty';
  $(neckSelector).each(function() {
  totalQty += parseInt($(this).val());
  });
  
  $('.stock-value').text(totalQty);

  if ( labelStock < totalQty ) {
    
    $('.addLabelsButton').addClass('hide');
    $('.label-stock-low').removeClass('hide'); 
    if ( $('.remove.label-product').length > 0 ) {
      setTimeout(function(){ $('.remove.label-product')[0].click()},100);
    }

  } else if ( totalQty < 1 ) {
       $('.addLabelsButton').addClass('hide');
     if ( $('.remove.label-product').length > 0 && !(rules && rules.hasPrint) ) {
       setTimeout(function(){ $('.remove.label-product')[0].click()},100);
      }
  } else {
    if ( $('.remove.label-product').length == 0 ) {
      $('.add-labels-link').removeClass('hide');
      $('.remove-labels-link').addClass('hide');  
    } else {
      $('.add-labels-link').addClass('hide');
      $('.remove-labels-link').removeClass('hide');  
    }

    $('.addLabelsButton').removeClass('hide');
    $('.label-stock-low ').addClass('hide');

  }

  ExtendCartDenimLabels();
  if ( typeof ExtendCartPrintLabels === 'function' ) {
    ExtendCartPrintLabels();
  }
}

// Tipos de produto que contam para as etiquetas de denim. Tem de acompanhar o
// denim_label_types do snippet cart-form.liquid.
var DENIM_LABEL_TYPES = ['denim', 'canvas pants'];

function ExtendCartDenimLabels() {

  const denimStockField = $('#denim_label_stock_qty');
  if ( denimStockField.length === 0 ) {
    return;
  }
  const denimStock = parseInt(denimStockField.val());

  var denimQty = 0;
  $('.cart-item:not([data-no-label])').each(function() {
    var itemType = ($(this).attr('data-product-type') || '').trim().toLowerCase();
    if ( DENIM_LABEL_TYPES.indexOf(itemType) === -1 ) {
      return;
    }
    $(this).find('.cart-qty').each(function() {
      var qty = parseInt($(this).val());
      if ( !isNaN(qty) ) {
        denimQty += qty;
      }
    });
  });

  $('.denim-stock-value').text(denimQty);

  if ( denimStock < denimQty ) {

    $('.addDenimLabelsButton').addClass('hide');
    $('.denim-label-stock-low').removeClass('hide');
    if ( $('.remove.denim-label-product').length > 0 ) {
      setTimeout(function(){ $('.remove.denim-label-product')[0].click()},100);
    }

  } else if ( denimQty < 1 ) {
       $('.addDenimLabelsButton').addClass('hide');
     if ( $('.remove.denim-label-product').length > 0 ) {
       setTimeout(function(){ $('.remove.denim-label-product')[0].click()},100);
      }
  } else {
    if ( $('.remove.denim-label-product').length == 0 ) {
      $('.add-denim-labels-link').removeClass('hide');
      $('.remove-denim-labels-link').addClass('hide');
    } else {
      $('.add-denim-labels-link').addClass('hide');
      $('.remove-denim-labels-link').removeClass('hide');
    }

    $('.addDenimLabelsButton').removeClass('hide');
    $('.denim-label-stock-low').addClass('hide');

  }
}

document.addEventListener('DOMContentLoaded', function() {
  const toggleButton = document.querySelector('[data-js-toggle]');
  const toggleContent = document.querySelector('[data-js-content]');

  if(toggleButton) {
    toggleButton.addEventListener('click', function() {
      const expanded = toggleButton.getAttribute('aria-expanded') === 'true';
  
      toggleButton.setAttribute('aria-expanded', !expanded);
      toggleContent.setAttribute('aria-hidden', expanded);
    });
  }
});

// BSS-custom-show MC
const currentPath = window.location.pathname;

const pathsToCheck = ['/product', '/collection', '/search', '/cart'];

const containsPath = pathsToCheck.some(function(path) {
    return currentPath.includes(path);
});

if (containsPath) {
    
} else {
    const intervalId = setInterval(() => {
      const block = document.querySelector('.bss-currency-wrapper')
      if (block) {
        block.style.opacity = 0
        clearInterval(intervalId);
      }
    }, 500);
    setTimeout(() => {
      clearInterval(intervalId);
    }, 3000)
}
// BSS-custom-show MC

(function() {
  var PRINT_VARIANT_ID = 55324808839505;
  var NECK_VARIANT_ID = '42260648198334';
  var SKIP_VARIANT_IDS = {
    '55324808839505': true,
    '42260648198334': true,
    '54323017875793': true
  };
  var PRINT_EXCLUDED = [
    'loose fit denim shorts',
    'relaxed denim jacket',
    'loose fit jeans',
    '290 twill cap',
    'relaxed straight canvas pants',
    'relaxed knit sweater',
    'cargo pants v2'
  ];
  var NO_LABEL = ['twill cap', 'canvas tote bag'];
  var choiceMemory = {};
  var choicePending = {};

  function labelRules() {
    var el = document.getElementById('watc-label-rules');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  window.WATCLabelState = function() {
    var rules = labelRules();
    if (!rules) return null;
    return {
      hasPrint: !!rules.hasPrint || cartHasNeckPrint(),
      hasNeck: !!rules.hasNeck,
      printVariantId: rules.printVariantId || PRINT_VARIANT_ID
    };
  };

  function containsAny(title, list) {
    return list.some(function(keyword) { return title.indexOf(keyword) !== -1; });
  }

  function lineQty(el) {
    if (!el) return 0;
    var input = el.querySelector('.cart-qty');
    var qty = input ? parseInt(input.value, 10) : parseInt(el.getAttribute('data-qty'), 10);
    return isNaN(qty) ? 0 : qty;
  }

  function itemTitle(el) {
    return (el.getAttribute('data-product-title') || '').toLowerCase();
  }

  function isServiceProduct(title) {
    title = String(title || '').toLowerCase();
    return title.indexOf('custom neck print') !== -1 || title.indexOf('apply my') !== -1;
  }

  function canTakePrint(el) {
    if (!el || el.hasAttribute('data-no-label') || el.getAttribute('data-mockup') === 'true') return false;
    var title = itemTitle(el);
    if (!title || isServiceProduct(title)) return false;
    if (containsAny(title, NO_LABEL) || containsAny(title, PRINT_EXCLUDED)) return false;
    return true;
  }

  function printEligibleQty() {
    var qty = 0;
    document.querySelectorAll('.cart-item').forEach(function(el) {
      if (canTakePrint(el)) qty += lineQty(el);
    });
    return qty;
  }

  function appliedPrintQty() {
    var qty = 0;
    document.querySelectorAll('.cart-item').forEach(function(el) {
      if (el.getAttribute('data-applied-label') === 'Custom Print Label') qty += lineQty(el);
    });
    return qty;
  }

  function cartHasNeckPrint() {
    var found = false;
    document.querySelectorAll('.cart-item').forEach(function(el) {
      if (itemTitle(el).indexOf('custom neck print') !== -1) found = true;
    });
    return found;
  }

  function currentProduct() {
    var page = document.querySelector('product-page[data-product-title]');
    if (!page) return null;
    return {
      id: page.getAttribute('data-id'),
      title: page.getAttribute('data-product-title') || ''
    };
  }

  function isCurrentProductVariant(variantId) {
    var id = String(variantId || '');
    var page = document.querySelector('product-page');
    if (!id || !page) return false;
    if (page.querySelector('product-form [name="id"][value="' + id + '"]')) return true;
    var input = page.querySelector('[id="' + id + '"]');
    return !!(input && input.closest('.variant-item__quantity-wrapper'));
  }

  function showChoice(product) {
    var title = product.title || 'this product';
    var lower = title.toLowerCase();
    var blocked = containsAny(lower, NO_LABEL) || isServiceProduct(lower);
    if (blocked) return Promise.resolve('');

    var printBlocked = containsAny(lower, PRINT_EXCLUDED);
    if (Object.prototype.hasOwnProperty.call(choiceMemory, product.id)) return Promise.resolve(choiceMemory[product.id]);
    if (choicePending[product.id]) return choicePending[product.id];

    choicePending[product.id] = new Promise(function(resolve) {
      var existing = document.getElementById('watc-label-choice');
      if (existing) existing.remove();

      var modal = document.createElement('div');
      modal.id = 'watc-label-choice';
      modal.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);z-index:100000;display:flex;justify-content:center;align-items:center;';
      var printButton = printBlocked ? '' : '<button type="button" data-choice="Custom Print Label" class="button button--solid" style="width:100%;margin:0;box-sizing:border-box;">Custom Print Label</button>';
      var safeTitle = String(title).replace(/[&<>"']/g, function(char) {
        return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char];
      });
      var message = printBlocked
        ? safeTitle + ' can\'t take a Custom Print Label. Apply your Custom Neck Label, or add it without a label.'
        : 'Choose the label for ' + safeTitle + '.<br>The same choice is used for every size of this product. You can also add it without a label.';
      modal.innerHTML = '<div style="background:#fff;padding:2rem;border-radius:3px;text-align:center;max-width:400px;margin:auto;position:relative;color:#111111;">' +
        '<button type="button" data-choice-cancel class="close-modal site-close-handle" title="Close" style="position:absolute;top:10px;right:10px;background:transparent;border:none;cursor:pointer;">' +
        '<span class="visually-hidden">Close modal</span><span class="hamburger-menu" aria-hidden="true">' +
        '<svg aria-hidden="true" focusable="false" role="presentation" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.41418 0L16.9705 15.5563L15.5563 16.9706L-2.89679e-05 1.41421L1.41418 0Z" fill="#111111"></path><path d="M16.9706 1.41431L1.41423 16.9707L1.85966e-05 15.5564L15.5564 9.31025e-05L16.9706 1.41431Z" fill="#111111"></path></svg></span></button>' +
        '<p style="font-size:16px;line-height:1.5;margin-bottom:1.5rem;margin-top:1.5rem;color:#111111;">' + message + '</p>' +
        '<div style="display:flex;flex-direction:column;gap:12px;">' +
        '<button type="button" data-choice="Custom Neck Label" class="button button--solid" style="width:100%;margin:0;box-sizing:border-box;">Custom Neck Label</button>' +
        printButton +
        '<button type="button" data-choice="No label" class="button button--outline" style="width:100%;margin:0;box-sizing:border-box;">No label</button></div></div>';
      document.body.appendChild(modal);

      function finish(value) {
        modal.remove();
        if (value === null) {
          resolve(null);
          return;
        }
        choiceMemory[product.id] = value;
        resolve(value);
      }

      modal.addEventListener('click', function(event) {
        var choice = event.target.closest('[data-choice]');
        if (choice) {
          finish(choice.getAttribute('data-choice'));
          return;
        }
        if (event.target.closest('[data-choice-cancel]') || event.target === modal) finish('No label');
      });
    }).finally(function() {
      delete choicePending[product.id];
    });

    return choicePending[product.id];
  }

  function forgetChoice(productId) {
    delete choiceMemory[productId];
    delete choiceMemory[String(productId)];
    delete skippedChoice[productId];
    delete skippedChoice[String(productId)];
  }

  function choiceForProduct(product) {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        var lines = (cart.items || []).filter(function(item) {
          return String(item.product_id) === String(product.id);
        });
        if (!lines.length) {
          forgetChoice(product.id);
          return showChoice(product);
        }
        var found = lines.find(function(item) {
          return item.properties && item.properties.Label;
        });
        if (found) {
          choiceMemory[product.id] = found.properties.Label;
          return found.properties.Label;
        }
        if (Object.prototype.hasOwnProperty.call(choiceMemory, product.id)) return choiceMemory[product.id];
        return showChoice(product);
      })
      .catch(function() { return showChoice(product); });
  }

  function withLabel(body, label) {
    if (!label) return body;
    if (typeof body !== 'string') return body;
    var trimmed = body.trim();
    if (trimmed.charAt(0) === '{') {
      var data = JSON.parse(trimmed);
      data.properties = data.properties || {};
      data.properties.Label = label;
      return JSON.stringify(data);
    }
    if (body.indexOf('properties%5BLabel%5D=') !== -1 || body.indexOf('properties[Label]=') !== -1) return body;
    return body + '&properties%5BLabel%5D=' + encodeURIComponent(label);
  }

  function variantFromBody(body) {
    if (typeof body !== 'string') return '';
    var trimmed = body.trim();
    if (trimmed.charAt(0) === '{') {
      try {
        var data = JSON.parse(trimmed);
        return String(data.id || '');
      } catch (e) { return ''; }
    }
    var match = body.match(/(?:^|&)id=(\d+)/);
    return match ? match[1] : '';
  }

  function printNewIds() {
    try {
      var raw = sessionStorage.getItem('watc-print-new-ids');
      if (!raw) return null;
      var ids = JSON.parse(raw);
      return ids && ids.length ? ids.map(String) : null;
    } catch (e) {
      return null;
    }
  }

  if (!window.__watcLabelFetch) {
    window.__watcLabelFetch = true;
    var nativeFetch = window.fetch.bind(window);
    window.fetch = function(input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (url.indexOf('/cart/add') === -1 || !init || typeof init.body !== 'string' || init.__watcLabelReady) {
        return nativeFetch(input, init);
      }
      var rules = window.WATCLabelState ? window.WATCLabelState() : null;
      if (!rules || !rules.hasPrint || !rules.hasNeck) return nativeFetch(input, init);

      var variantId = variantFromBody(init.body);
      if (!variantId || SKIP_VARIANT_IDS[variantId] || !isCurrentProductVariant(variantId)) {
        return nativeFetch(input, init);
      }
      var product = currentProduct();
      if (!product || !product.id) return nativeFetch(input, init);
      if (containsAny(product.title.toLowerCase(), NO_LABEL) || isServiceProduct(product.title)) return nativeFetch(input, init);

      return choiceForProduct(product).then(function(label) {
        if (label === null) {
          var bulk = document.getElementById('add-products-in-bulk');
          if (bulk) bulk.classList.remove('loading');
          return Promise.reject(new Error('label-choice-cancelled'));
        }
        var next = Object.assign({}, init, { body: withLabel(init.body, label), __watcLabelReady: true });
        return nativeFetch(input, next);
      });
    };
  }

  function refreshCartSection() {
    if (document.body.classList.contains('template-cart')) {
      if (window.__watcCartReloading) return Promise.resolve();
      window.__watcCartReloading = true;
      window.location.reload();
      return Promise.resolve();
    }
    return fetch('?section_id=helper-cart')
      .then(function(response) { return response.text(); })
      .then(function(text) {
        var parsed = new DOMParser().parseFromString(text, 'text/html');
        var nextForm = parsed.getElementById('AjaxCartForm');
        var form = document.getElementById('AjaxCartForm');
        if (nextForm && form) {
          form.innerHTML = nextForm.innerHTML;
          if (typeof form.ajaxifyCartItems === 'function') form.ajaxifyCartItems();
        }
        var nextSubtotal = parsed.getElementById('AjaxCartSubtotal');
        var subtotal = document.getElementById('AjaxCartSubtotal');
        if (nextSubtotal && subtotal) subtotal.innerHTML = nextSubtotal.innerHTML;
      })
      .catch(function() {});
  }

  function isPrintFee(item) {
    return !!item && String(item.variant_id) === String(PRINT_VARIANT_ID);
  }

  function printQtyFromCart(cart, rules) {
    var qty = 0;
    (cart.items || []).forEach(function(item) {
      if (isPrintFee(item)) return;
      var title = String(item.product_title || item.title || '').toLowerCase();
      if (isServiceProduct(title)) return;
      if (rules.hasNeck) {
        if (item.properties && item.properties.Label === 'Custom Print Label') qty += item.quantity;
      } else if (!containsAny(title, NO_LABEL) && !containsAny(title, PRINT_EXCLUDED)) {
        qty += item.quantity;
      }
    });
    return qty;
  }

  function syncPrintQty() {
    if (window.__watcPrintSyncing) return;
    var rules = window.WATCLabelState ? window.WATCLabelState() : null;
    window.__watcPrintSyncing = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        var qty = rules && rules.hasPrint ? printQtyFromCart(cart, rules) : 0;
        var fee = (cart.items || []).find(isPrintFee);
        if (!fee || fee.quantity === qty) return false;
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: fee.key, quantity: qty })
        }).then(function(response) {
          if (!response.ok) throw new Error('print qty');
          return true;
        });
      })
      .then(function(changed) {
        if (changed) return refreshCartSection();
      })
      .catch(function() {})
      .finally(function() {
        window.__watcPrintSyncing = false;
      });
  }

  var skippedChoice = {};

  function needsLabelChoice(el) {
    if (!el || el.hasAttribute('data-no-label') || el.getAttribute('data-mockup') === 'true') return false;
    if (el.getAttribute('data-applied-label')) return false;
    var title = itemTitle(el);
    var productId = el.getAttribute('data-product-id');
    if (!productId || skippedChoice[productId]) return false;
    if (!title || isServiceProduct(title)) return false;
    if (containsAny(title, NO_LABEL)) return false;
    return true;
  }

  function applyChoiceToCart(productId, label) {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        var lines = (cart.items || []).filter(function(item) {
          return String(item.product_id) === String(productId);
        });
        var chain = Promise.resolve();
        lines.forEach(function(item) {
          chain = chain.then(function() {
            var props = {};
            Object.keys(item.properties || {}).forEach(function(key) {
              if (item.properties[key]) props[key] = item.properties[key];
            });
            if (label) props.Label = label;
            else delete props.Label;
            if (label === 'Custom Print Label') window.__watcPrintFeeDismissed = false;
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: props })
            });
          });
        });
        return chain;
      });
  }

  function productsNeedingChoice() {
    var seen = {};
    var list = [];
    document.querySelectorAll('.cart-item').forEach(function(el) {
      if (!needsLabelChoice(el)) return;
      var id = el.getAttribute('data-product-id');
      if (!id || seen[id]) return;
      seen[id] = true;
      list.push({
        id: id,
        title: el.getAttribute('data-product-title') || ''
      });
    });
    return list;
  }

  function promptMissingChoices() {
    if (window.__watcChoiceBusy || document.getElementById('watc-label-choice')) return false;
    var pending = productsNeedingChoice();
    if (!pending.length) return false;
    window.__watcChoiceBusy = true;
    var changed = false;
    var chain = Promise.resolve();
    pending.forEach(function(product) {
      chain = chain.then(function() {
        return showChoice(product).then(function(label) {
          if (label === null) {
            skippedChoice[product.id] = true;
            return null;
          }
          changed = true;
          return applyChoiceToCart(product.id, label);
        });
      });
    });
    chain.finally(function() {
      window.__watcChoiceBusy = false;
      if (!changed) return;
      refreshCartSection().then(function() {
        if (window.__watcCartReloading) return;
        if (typeof ExtendCartLabels === 'function') ExtendCartLabels();
      });
    });
    return true;
  }

  function printKeepRequested() {
    try { return sessionStorage.getItem('watc-print-keep') === '1'; } catch (e) { return false; }
  }

  function setPrintKeep(on) {
    try {
      if (on) sessionStorage.setItem('watc-print-keep', '1');
      else sessionStorage.removeItem('watc-print-keep');
    } catch (e) {}
  }

  function addPrintFee(qty) {
    if (window.__watcPrintSyncing || qty < 1) return;
    if (!cartHasNeckPrint()) setPrintKeep(true);
    window.__watcPrintSyncing = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        if ((cart.items || []).some(isPrintFee)) return false;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: PRINT_VARIANT_ID, quantity: qty, properties: { '_customer': 'b2b' } })
        }).then(function(response) {
          if (!response.ok) throw new Error('print add');
          return true;
        });
      })
      .then(function(changed) {
        if (changed) return refreshCartSection();
      })
      .catch(function() {})
      .finally(function() {
        window.__watcPrintSyncing = false;
      });
  }

  function neckApplyInDom() {
    return !!document.querySelector('.cart-item[data-variant="' + NECK_VARIANT_ID + '"]');
  }

  function canTakeNeck(el) {
    if (!el || el.hasAttribute('data-no-label') || el.getAttribute('data-mockup') === 'true') return false;
    var title = itemTitle(el);
    if (!title || isServiceProduct(title)) return false;
    if (containsAny(title, NO_LABEL)) return false;
    if (String(el.getAttribute('data-variant')) === NECK_VARIANT_ID) return false;
    if (String(el.getAttribute('data-variant')) === String(PRINT_VARIANT_ID)) return false;
    return true;
  }

  function stampNeckLabels() {
    if (window.__watcLabelClearing || window.__watcPrintSyncing || window.__watcChoiceBusy) return false;
    if (!neckApplyInDom()) return false;
    var pending = [];
    var seen = {};
    document.querySelectorAll('.cart-item').forEach(function(el) {
      if (!canTakeNeck(el) || el.getAttribute('data-applied-label')) return;
      var id = el.getAttribute('data-product-id');
      if (!id || seen[id]) return;
      seen[id] = true;
      pending.push(id);
    });
    if (!pending.length) return false;
    window.__watcLabelClearing = true;
    var chain = Promise.resolve();
    pending.forEach(function(id) {
      chain = chain.then(function() {
        return applyChoiceToCart(id, 'Custom Neck Label');
      });
    });
    chain.then(function() {
      return refreshCartSection();
    }).catch(function() {}).finally(function() {
      window.__watcLabelClearing = false;
    });
    return true;
  }

  function clearAssumedLabels() {
    if (window.__watcLabelClearing || window.__watcPrintSyncing || window.__watcChoiceBusy) return false;
    if (!document.querySelector('.cart-item[data-applied-label]')) return false;
    window.__watcLabelClearing = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        var lines = (cart.items || []).filter(function(item) {
          return item.properties && item.properties.Label;
        });
        if (!lines.length) return false;
        var chain = Promise.resolve();
        lines.forEach(function(item) {
          chain = chain.then(function() {
            var props = {};
            Object.keys(item.properties || {}).forEach(function(key) {
              if (key !== 'Label' && item.properties[key]) props[key] = item.properties[key];
            });
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: props })
            });
          });
        });
        return chain.then(function() { return true; });
      })
      .then(function(changed) {
        if (changed) return refreshCartSection();
      })
      .catch(function() {})
      .finally(function() {
        window.__watcLabelClearing = false;
      });
    return true;
  }

  window.ExtendCartPrintLabels = function() {
    if (window.__watcPrintSyncing || window.__watcChoiceBusy || window.__watcLabelClearing) return;
    var rules = window.WATCLabelState ? window.WATCLabelState() : null;
    window.WATCLabels = window.WATCLabels || {};
    window.WATCLabels.rules = rules;
    if (neckApplyInDom()) window.__watcNeckApplyWasPresent = true;
    if (stampNeckLabels()) return;
    if (neckApplyInDom() && !document.querySelector('.cart-item[data-applied-label="Custom Neck Label"]')) {
      dropUnusedNeckFee();
      return;
    }
    if (cartHasNeckPrint()) {
      setPrintKeep(false);
    } else if (printApplicationInDom() && !printKeepRequested()) {
      dropUnavailablePrint();
      return;
    }
    if ((!rules || !rules.hasPrint || !rules.hasNeck) && !neckApplyInDom()) {
      if (clearAssumedLabels()) return;
    }

    var qty = 0;
    document.querySelectorAll('.cart-item').forEach(function(el) {
      if (String(el.getAttribute('data-variant')) === String(PRINT_VARIANT_ID)) return;
      if (rules && rules.hasNeck) {
        if (el.getAttribute('data-applied-label') === 'Custom Print Label') qty += lineQty(el);
      } else if (rules && rules.hasPrint && canTakePrint(el)) {
        qty += lineQty(el);
      }
    });

    if (!rules || !rules.hasPrint) return;
    if (rules.hasNeck && !window.__watcPrintFeeDismissed && !neckApplyInDom() && promptMissingChoices()) return;

    var box = document.querySelector('.addPrintLabelsButton');
    var input = document.getElementById('print_label_qty');
    var addLink = document.querySelector('.add-print-labels-link');
    var removeLink = document.querySelector('.remove-print-labels-link');
    var hasLine = document.querySelector('.remove.print-label-product');
    var printable = 0;
    document.querySelectorAll('.cart-item').forEach(function(el) {
      if (canTakePrint(el)) printable += lineQty(el);
    });

    if (!box) return;
    if (input) input.value = String(Math.max(qty, 1));

    var applied = appliedPrintQty();
    if (applied > 0) {
      box.classList.remove('hide');
      if (addLink) addLink.classList.add('hide');
      if (removeLink) removeLink.classList.remove('hide');
      if (hasLine) syncPrintQty();
      else if (!window.__watcPrintFeeDismissed && rules.hasNeck) addPrintFee(applied);
      return;
    }

    if (hasLine) syncPrintQty();
    if (printable > 0 && cartHasNeckPrint()) {
      box.classList.remove('hide');
      if (addLink) addLink.classList.remove('hide');
      if (removeLink) removeLink.classList.add('hide');
    } else {
      box.classList.add('hide');
    }
  };

  function printApplicationInDom() {
    if (document.querySelector('.cart-item[data-variant="' + PRINT_VARIANT_ID + '"]')) return true;
    var found = false;
    document.querySelectorAll('.cart-item').forEach(function(el) {
      if (el.getAttribute('data-applied-label') === 'Custom Print Label') found = true;
    });
    return found;
  }

  function dropUnavailablePrint() {
    if (window.__watcPrintSyncing || window.__watcLabelClearing) return;
    window.__watcPrintSyncing = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        var chain = Promise.resolve();
        var changed = false;
        (cart.items || []).forEach(function(item) {
          if (!item.properties || item.properties.Label !== 'Custom Print Label') return;
          changed = true;
          delete choiceMemory[String(item.product_id)];
          delete choiceMemory[item.product_id];
          chain = chain.then(function() {
            var props = {};
            Object.keys(item.properties).forEach(function(key) {
              if (key !== 'Label' && item.properties[key]) props[key] = item.properties[key];
            });
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: props })
            });
          });
        });
        var fee = (cart.items || []).find(isPrintFee);
        if (fee) {
          changed = true;
          chain = chain.then(function() {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: fee.key, quantity: 0 })
            });
          });
        }
        return chain.then(function() { return changed; });
      })
      .then(function(changed) {
        if (changed) return refreshCartSection();
      })
      .catch(function() {})
      .finally(function() {
        window.__watcPrintSyncing = false;
      });
  }

  function undoPrintApplication() {
    if (window.__watcPrintSyncing || window.__watcLabelClearing) return;
    window.__watcPrintSyncing = true;
    window.__watcPrintFeeDismissed = true;
    setPrintKeep(false);
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        var chain = Promise.resolve();
        (cart.items || []).forEach(function(item) {
          if (!item.properties || item.properties.Label !== 'Custom Print Label') return;
          skippedChoice[String(item.product_id)] = true;
          delete choiceMemory[String(item.product_id)];
          delete choiceMemory[item.product_id];
          chain = chain.then(function() {
            var props = {};
            Object.keys(item.properties).forEach(function(key) {
              if (key !== 'Label' && item.properties[key]) props[key] = item.properties[key];
            });
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: props })
            });
          });
        });
        var fee = (cart.items || []).find(isPrintFee);
        if (fee) {
          chain = chain.then(function() {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: fee.key, quantity: 0 })
            });
          });
        }
        return chain.then(function() { return true; });
      })
      .then(function() { return refreshCartSection(); })
      .catch(function() {})
      .finally(function() {
        window.__watcPrintSyncing = false;
      });
  }

  function printableProducts() {
    var grouped = {};
    document.querySelectorAll('.cart-item').forEach(function(el) {
      if (!canTakePrint(el)) return;
      var id = el.getAttribute('data-product-id');
      if (!id) return;
      if (!grouped[id]) {
        grouped[id] = {
          id: id,
          title: el.getAttribute('data-product-title') || 'this product',
          qty: 0
        };
      }
      grouped[id].qty += lineQty(el);
    });
    return Object.keys(grouped).map(function(id) { return grouped[id]; });
  }

  function removeNeckAndAskPrint() {
    if (window.__watcPrintSyncing || window.__watcLabelClearing) return;
    window.__watcPrintSyncing = true;
    window.__watcNeckApplyWasPresent = false;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        var offered = [];
        var chain = Promise.resolve();
        (cart.items || []).forEach(function(item) {
          if (String(item.variant_id) === NECK_VARIANT_ID) {
            chain = chain.then(function() {
              return fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ id: item.key, quantity: 0 })
              });
            });
            return;
          }
          if (!item.properties || item.properties.Label !== 'Custom Neck Label') return;
          var title = String(item.product_title || item.title || '').toLowerCase();
          var canPrint = !isServiceProduct(title) && !containsAny(title, NO_LABEL) && !containsAny(title, PRINT_EXCLUDED);
          if (canPrint) {
            var existing = null;
            offered.forEach(function(product) {
              if (String(product.id) === String(item.product_id)) existing = product;
            });
            if (existing) existing.qty += item.quantity;
            else offered.push({ id: String(item.product_id), title: item.product_title || item.title, qty: item.quantity });
          }
          skippedChoice[String(item.product_id)] = true;
          chain = chain.then(function() {
            var props = {};
            Object.keys(item.properties).forEach(function(key) {
              if (key !== 'Label' && item.properties[key]) props[key] = item.properties[key];
            });
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: props })
            });
          });
        });
        return chain.then(function() { return offered; });
      })
      .then(function(offered) {
        window.__watcPrintSyncing = false;
        if (offered && offered.length && document.body.classList.contains('template-cart')) {
          sessionStorage.setItem('watc-print-offer', JSON.stringify(offered));
        }
        return refreshCartSection().then(function() {
          if (window.__watcCartReloading || !offered || !offered.length) return;
          askWhereToApplyPrint(offered);
        });
      })
      .catch(function() {
        window.__watcPrintSyncing = false;
      });
  }

  function dropUnusedNeckFee() {
    if (window.__watcPrintSyncing || window.__watcLabelClearing) return;
    window.__watcPrintSyncing = true;
    dropNeckFeeIfUnused()
      .then(function(changed) {
        if (changed) return refreshCartSection();
      })
      .catch(function() {})
      .finally(function() {
        window.__watcPrintSyncing = false;
      });
  }

  function dropNeckFeeIfUnused() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        var stillNeck = (cart.items || []).some(function(item) {
          return item.properties && item.properties.Label === 'Custom Neck Label';
        });
        if (stillNeck) return false;
        var fee = (cart.items || []).find(function(item) {
          return String(item.variant_id) === NECK_VARIANT_ID;
        });
        if (!fee) return false;
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: fee.key, quantity: 0 })
        });
      });
  }

  function askWhereToApplyPrint(preset, message, allowAddOthers) {
    if (window.__watcChoiceBusy || document.getElementById('watc-label-choice')) return;
    var products = preset && preset.length ? preset : printableProducts();
    if (!products.length) return;
    window.__watcChoiceBusy = true;
    var modal = document.createElement('div');
    modal.id = 'watc-label-choice';
    modal.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);z-index:100000;display:flex;justify-content:center;align-items:center;';
    var rows = products.map(function(product) {
      var safeTitle = String(product.title).replace(/[&<>"']/g, function(char) {
        return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char];
      });
      return '<label style="display:flex;gap:10px;align-items:center;justify-content:center;margin:10px 0;color:#111111;">' +
        '<input type="checkbox" data-print-product="' + product.id + '" data-print-qty="' + product.qty + '" checked>' +
        '<span>' + safeTitle + ' (' + product.qty + ')</span></label>';
    }).join('');
    modal.innerHTML = '<div style="background:#fff;padding:2rem;border-radius:3px;text-align:center;max-width:420px;margin:auto;position:relative;color:#111111;">' +
      '<button type="button" data-print-cancel class="close-modal site-close-handle" title="Close" style="position:absolute;top:10px;right:10px;background:transparent;border:none;cursor:pointer;">' +
      '<span class="visually-hidden">Close modal</span><span class="hamburger-menu" aria-hidden="true">' +
      '<svg aria-hidden="true" focusable="false" role="presentation" width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.41418 0L16.9705 15.5563L15.5563 16.9706L-2.89679e-05 1.41421L1.41418 0Z" fill="#111111"></path><path d="M16.9706 1.41431L1.41423 16.9707L1.85966e-05 15.5564L15.5564 9.31025e-05L16.9706 1.41431Z" fill="#111111"></path></svg></span></button>' +
      '<p style="font-size:16px;line-height:1.5;margin:1.5rem 0;color:#111111;">' + (message || 'Choose the products for <strong>Custom Print Label</strong>. The 1,50€ fee is charged for each unit.') + '</p>' +
      rows +
      '<div style="display:flex;flex-direction:column;gap:12px;margin-top:16px;">' +
      '<button type="button" data-print-confirm class="button button--solid" style="width:100%;margin:0;">Apply print label</button>' +
      (allowAddOthers ? '<button type="button" data-print-add-others class="button button--outline" style="width:100%;margin:0;">Add other products</button>' : '') +
      '</div>' +
      '</div>';
    document.body.appendChild(modal);

    function closeModal() {
      modal.remove();
      window.__watcChoiceBusy = false;
    }

    modal.addEventListener('click', function(event) {
      if (event.target.closest('[data-print-add-others]')) {
        var kept = [];
        document.querySelectorAll('.cart-item').forEach(function(el) {
          var id = el.getAttribute('data-product-id');
          if (id && kept.indexOf(String(id)) === -1) kept.push(String(id));
        });
        sessionStorage.setItem('watc-print-new-ids', JSON.stringify(kept));
        closeModal();
        window.location.href = '/collections/the-blanks-collection-b2b';
        return;
      }
      if (event.target.closest('[data-print-cancel]') || event.target === modal) {
        closeModal();
        return;
      }
      if (!event.target.closest('[data-print-confirm]')) return;
      var selected = [];
      modal.querySelectorAll('[data-print-product]:checked').forEach(function(input) {
        selected.push({
          id: input.getAttribute('data-print-product'),
          qty: parseInt(input.getAttribute('data-print-qty'), 10) || 0
        });
      });
      closeModal();
      if (!selected.length) return;
      sessionStorage.removeItem('watc-print-new-ids');
      window.__watcPrintFeeDismissed = false;
      window.__watcPrintSyncing = true;
      var chain = Promise.resolve();
      var total = 0;
      selected.forEach(function(product) {
        total += product.qty;
        delete skippedChoice[product.id];
        chain = chain.then(function() {
          return applyChoiceToCart(product.id, 'Custom Print Label');
        });
      });
      chain.then(function() {
        return dropNeckFeeIfUnused();
      }).then(function() {
        window.__watcPrintSyncing = false;
        addPrintFee(total);
      }).catch(function() {
        window.__watcPrintSyncing = false;
      });
    });
  }

  document.addEventListener('click', function(event) {
    if (event.target.closest('.add-print-labels-link')) {
      event.preventDefault();
      event.stopPropagation();
      askWhereToApplyPrint();
      return;
    }
    if (event.target.closest('.print-label-product') || event.target.closest('.remove-print-labels-link')) {
      event.preventDefault();
      event.stopPropagation();
      undoPrintApplication();
      return;
    }
    var neckRemove = event.target.closest('.label-product');
    var neckRules = window.WATCLabelState ? window.WATCLabelState() : null;
    if (neckRemove && !event.target.closest('.denim-label-product') && neckRules && neckRules.hasPrint) {
      event.preventDefault();
      event.stopPropagation();
      removeNeckAndAskPrint();
      return;
    }

    var closeWarning = event.target.closest('[data-print-warning-close]');
    var warning = document.getElementById('print-label-warning');
    if (warning && (closeWarning || event.target === warning)) warning.style.display = 'none';
  }, true);

  document.addEventListener('submit', function(event) {
    if (!event.target.closest('.cart-print-label-product')) return;
    event.preventDefault();
    event.stopPropagation();
    askWhereToApplyPrint();
  }, true);

  document.addEventListener('click', function(event) {
    var checkout = event.target.closest('#btncheckout');
    if (!checkout || !cartHasNeckPrint() || appliedPrintQty() > 0) return;
    event.preventDefault();
    event.stopPropagation();
    var candidates = printableProducts();
    if (!candidates.length) {
      var warning = document.getElementById('print-label-warning');
      if (warning) {
        if (warning.parentNode !== document.body) document.body.appendChild(warning);
        warning.style.display = 'flex';
      }
      return;
    }
    askWhereToApplyPrint(candidates, 'Custom Neck Print is in your cart, but it is not applied to any product. Switch these products from <strong>Custom Neck Label</strong> to <strong>Custom Print Label</strong>, or add other products and choose a label for each one. The 1,50€ fee is charged for each printed unit.', true);
  }, true);

  try {
    var storedOffer = sessionStorage.getItem('watc-print-offer');
    if (storedOffer) {
      sessionStorage.removeItem('watc-print-offer');
      var offeredProducts = JSON.parse(storedOffer);
      if (offeredProducts && offeredProducts.length) askWhereToApplyPrint(offeredProducts);
    }
  } catch (e) {}
})();